module.exports = __webpack_public_path__ + "media/images/admin/icons/photo_library_blue-ba086d1bde94438ef612d09d985296f6.png";